
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryConfigurationSourceDatas, QueryConfigurationSourceDatasResponse, ConfigurationSourceData } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QueryConfigurationSourceDatasResponse, QueryConfigurationSourceDatasResponse>) => response?.data?.data?.sort((a, b) => a.name! > b.name! ? 1 : -1);
const getError = (response?: SWRResponse<QueryConfigurationSourceDatasResponse, QueryConfigurationSourceDatasResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QueryConfigurationSourceDatasResponse, QueryConfigurationSourceDatasResponse>) => ({});

export const useConfigurationSourceDatas = (query?: Partial<ConfigurationSourceData>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new QueryConfigurationSourceDatas(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationSourceDatas;